import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import './SearchInputBox.scss';

interface SearchInputBoxProps {
  darkMode: boolean,
  currentValue: string,
  onValueChange: (newVal: string) => void
};

const SearchInputRow = (props: SearchInputBoxProps) => {
  return (
    <div className={'search-inputbox' + (props.darkMode ? ' dark' : '')}>
      <label htmlFor="search">Search</label>
      <div className='inputbox-container'>
        <input
          type="text"
          id="search"
          name="search"
          placeholder='Search...'
          value={props.currentValue}
          onChange={e => props.onValueChange(e.target.value)}
        />
        <FontAwesomeIcon className='lens-icon' icon={faMagnifyingGlass} />
      </div>
    </div>
  );
};

export default SearchInputRow;